// @ts-nocheck
import { immerable } from "immer";

import { type BaseGroupInfo } from "./BaseGroupInfo";

export class GroupInfoModel implements BaseGroupInfo {
    [immerable] = true;
    readonly id: string = null;
    readonly description: string = null;
    readonly name: string = null;
    readonly isChanged: boolean = false;
    readonly updatedAt: Date = null as any as Date;
    readonly isArchived: boolean = false;
    readonly readOnly: boolean = false;

    static createDefault(data: Partial<GroupInfoModel> = {}): GroupInfoModel {
        return Object.assign(new GroupInfoModel(), data);
    }
}
